import ajax from '../utils/request'

/**
 * 每周精要相关 API
 * WeeklyService
 * @module service/Weekly
 */
export default {
  getPagerList () {
    return ajax({
      type: 'GET',
      url: 'public/v1/misc/getPaperList'
    })
  },
  /**
   * 每周精要订阅
   */
  subWeek (data) {
    if (!data.code) {
      data.code = ''
    }

    return ajax({
      url: `public/v1/user/subEmailV2`,
      data
    })
  },
  /**
   * 邮件订阅确认
   * @param {Object} data  数据
   * @param {String} data.email   确认的邮箱
   * @param {string} data.code    验证邮箱的数据
   */
  confirmEmail (data) {
    return ajax({
      url: 'public/v1/user/confirmEmail',
      data
    })
  }
}
